import React from 'react'
import { useSelector } from 'react-redux';

const url = process.env.REACT_APP_API_BASE_GEOSERVER;
function LeafletMap() {
  const {user} =  useSelector((state)=>state.auth) 
  return (
    <div>
      <iframe
        src={user?.usrType === 'SDI' ? `${url}/reclamation.php` : user?.usrType === 'NIA' ?`${url}/nia_reclamation.php` : "" }
        width="100%"
        height="1100px"
        style={{ border: "none" }}
        title="Dynamic Iframe"
      />
    </div>
  )
}

export default LeafletMap
